import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useVenues } from "../contexts/VenueContext";

interface VenueSelectorProps {
  value: string;
  onChange: (venueId: string) => void;
  variant?: "outlined" | "filled" | "standard";
  size?: "small" | "medium";
  fullWidth?: boolean;
  sx?: any;
  hideLabel?: boolean;
  allowNone?: boolean;
}

export default function VenueSelector({
  value,
  onChange,
  variant = "outlined",
  size = "medium",
  fullWidth = false,
  sx = {},
  hideLabel = false,
  allowNone = true,
}: VenueSelectorProps) {
  const { venues, isLoading } = useVenues();

  return (
    <FormControl
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      sx={{ minWidth: 200, ...sx }}
    >
      {!hideLabel && <InputLabel>Venue</InputLabel>}
      <Select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        label={hideLabel ? undefined : "Venue"}
        disabled={isLoading}
      >
        {allowNone && <MenuItem value="">No venue selected</MenuItem>}
        {venues.map((venue) => (
          <MenuItem key={venue.id} value={venue.id}>
            {venue.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
